import React, { Component } from 'react';
import PropTypes from 'prop-types';

import compact from 'lodash/compact';
import get from 'lodash/get';

class InputBase extends Component {

  listenKeyboard = e => {
    if (e.key == 'Enter' && typeof this.props.onEnter == 'function') {
      this.props.onEnter();
    }
  }

  isErrorHidden() {
    return this.props.showErrors !== true && this.props.formApi && this.submitsCount() == 0;
  }

  submitsCount() {
    return 'submitsCount' in this.props ? this.props.submitsCount : this.props.formApi.submits;
  }

  renderErrors(field) {
    if (this.isErrorHidden()) return null;

    const errors = this.errorsFor(field || this.props.name);

    if (!errors || errors.length == 0) return null;

    return (
      <p className="input-error">
        {errors.map((e, i) => {
          if (typeof e.message == 'object' && e.message.rawHtml) {
            return (
              <span key={`error_${i}`}>
                <span key={`error_${i}`} dangerouslySetInnerHTML={{ __html: e.message.rawHtml }} />
                {i < errors.length-1 ? ", " : ""}
              </span>
            )
          }
          else {
            return (
              <span key={`error_${i}`}>{e.message}{i < errors.length-1 ? ", " : ""}</span>
            )
          }
        }
        )}
      </p>
    );
  }

  errorsFor(field) {
    const fields = typeof field == "string" ? [field] : field;
    const errors = this.props.formApi ? this.props.formApi.errors : this.props.errors;
    
    if (!errors) return [];

    let fieldErrors = compact(fields.map(field => get(errors, field)));

    if (fieldErrors.length == 0 && this.props.serverErrors && this.props.serverErrors[field]) {
      fieldErrors = this.props.serverErrors[field];
    }

    return fieldErrors;
  }

  clearServerError(field) {
    if (!this.props.serverErrors) return;

    if(this.props.formApi.errors[field] && this.props.serverErrors[field]) {
      this.props.serverErrors[field].forEach(error => {
        if (error.code == this.props.formApi.errors[field].code) {
          this.props.formApi.setError(field, undefined);
        }
      });
    }

    if (typeof this.props.clearServerError == 'function') {
      this.props.clearServerError(this.props.name);
    }
  }

  inputClassName(baseClass, field = null) {
    const classes = [baseClass];

    const errors  = this.errorsFor(field || this.props.name);
    if (errors.length > 0 && !this.isErrorHidden()) classes.push("-error");

    return classes.join(' ');
  }

  blockClassNames() {
    const classes = [];
    if (this.props.className) classes.push(this.props.className);
    if (this.props.labelAsPlaceholder === true) classes.push("-compact");
    return classes.join(' ');
  }

  renderLabel() {
    if (this.props.labelAsPlaceholder === true || this.props.label === false) return null;

    return (
      <label className="input-label">
        {this.props.label}
        {this.props.labelSecondary ?
          <span className="input-labelSecondary">{this.props.labelSecondary}</span>
          : null
        }
      </label>
    );
  }

}

export default InputBase;
